/* eslint-disable import/no-named-as-default */
import create from "zustand";
import produce from "immer";
import { subscribeWithSelector } from "zustand/middleware";

import { DataService } from "base/services";
import { isEmpty } from "base/utils";
import { useAccountStore, useUserStore } from "base/stores";

let myTaskTimeout = null;

const STORE = {
  Preview: {
    mode: "web"
  },
  Type: "Process",
  flowModel: {},
  progressData: null,
  refreshTopNav: null,
  sharedWith: [],
  myTaskDetails: {},
  flowInfo: {},
  isSubmitLoading: undefined
};
const createWithImmer = (storeCreator) =>
  create(
    subscribeWithSelector((originalSet, originalGet) =>
      storeCreator((fn) => originalSet(produce(fn)), originalGet)
    )
  );
export const useProcessStore = createWithImmer((setState, getState) => ({
  ...STORE,
  setPreview: (data) => {
    setState((state) => {
      return {
        Preview: {
          ...state.Preview,
          ...data
        }
      };
    });
  },
  resetPreview: () => {
    setState(() => {
      return { Preview: STORE["Preview"] };
    });
  },
  setFlowModel: (data) => {
    setState((state) => {
      return { flowModel: data };
    });
  },
  setFlowInfo: (data) => {
    setState((state) => {
      return { flowInfo: data };
    });
  },
  setSharedwithInfo: (data) => {
    setState((state) => {
      return { sharedWith: data };
    });
  },
  getProgressData: async (modelId, instanceId, reportId) => {
    let url = `/process/2/${
      useAccountStore.getState()._id
    }/${modelId}/${instanceId}/progress`;
    if (reportId) {
      url = `/process-report/2/${
        useAccountStore.getState()._id
      }/${modelId}/${reportId}/${instanceId}/progress`;
    }
    let [fetchProgress] = DataService.get(url);
    let progressData = await fetchProgress();
    setState((state) => ({ progressData }));
  },
  setRefreshTopNav: (data) => {
    setState((state) => {
      return { refreshTopNav: data };
    });
  },
  setMytaskDetails: (mytask = [], modelId, isFromMyTask) => {
    let count = 0;
    clearTimeout(myTaskTimeout);
    if (!isEmpty(mytask)) {
      mytask.forEach((step) => (count += step.Count));
    }
    const currentUserId = useUserStore.getState().currentUser?._id;
    let localData = JSON.parse(localStorage.getItem("PROCESS_DETAILS") || "{}");
    localData[currentUserId] = localData[currentUserId] || {};
    const isNewActionItem =
      !isFromMyTask &&
      count > 0 &&
      count > localData[currentUserId][modelId]?.myTaskCount;
    if (isNewActionItem) {
      myTaskTimeout = setTimeout(
        () =>
          setState((state) => {
            return {
              myTaskDetails: {
                isNewActionItem: false,
                count: count
              }
            };
          }),
        3000
      );
    }
    localData[currentUserId][modelId] = {
      myTaskCount: count
    };
    localStorage.setItem("PROCESS_DETAILS", JSON.stringify(localData));
    setState((state) => {
      return {
        myTaskDetails: {
          isNewActionItem: isNewActionItem,
          count: count
        }
      };
    });
  },
  setPrintDownloadConfig: (printData, downloadData) => {
    setState((state) => {
      return {
        flowInfo: {
          ...getState().flowInfo,
          AllowPrint: printData,
          AllowDownload: downloadData
        }
      };
    });
  },
  setIsSubmitLoading: (status) => {
    setState((state) => {
      return {
        isSubmitLoading: status
      };
    });
  },
  resetProgressData: () => {
    setState(() => {
      return { progressData: null };
    });
  }
}));
